import script from "./TermsOfService.vue?vue&type=script&setup=true&lang=js"
export * from "./TermsOfService.vue?vue&type=script&setup=true&lang=js"

import "./TermsOfService.vue?vue&type=style&index=0&id=66165e05&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66165e05"]])

export default __exports__